import { CircleInfoIcon } from "@xola/icons";
import { Tooltip } from "@xola/ui-kit";
import React from "react";
import { Experience } from "types";
import { NoTranslate } from "./NoTranslate";
import { ProductImage } from "./ProductImage";

export const OverridingExperiencesList = ({ experiences }: { experiences: Experience[] }) => {
    return (
        <div className="flex flex-col space-y-3">
            <span className="font-bold">
                Overrides{" "}
                <Tooltip content="Products that use their own review settings are displayed here">
                    <CircleInfoIcon className="ml-2" />
                </Tooltip>
            </span>
            <div className="rounded-md border border-gray-lighter">
                {experiences.map((experience: Experience) => (
                    <div
                        key={experience.id}
                        className="flex h-10 items-center border-b border-gray-lighter p-2 last:border-b-0"
                    >
                        <ProductImage product={experience} size="tiny" />
                        <NoTranslate>{experience.name}</NoTranslate>
                    </div>
                ))}
            </div>
        </div>
    );
};
